import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Member = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.613 11.8369C13.4791 10.7968 14 9.45924 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 9.45924 2.52093 10.7968 3.38696 11.8369C4.50949 10.7761 6.17388 10.125 8 10.125C9.82612 10.125 11.4905 10.7761 12.613 11.8369ZM11.9113 12.5501C10.9953 11.6932 9.59748 11.125 8 11.125C6.40252 11.125 5.00468 11.6932 4.08873 12.5501C5.13905 13.4538 6.50574 14 8 14C9.49426 14 10.8609 13.4538 11.9113 12.5501ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM8 8.3125C8.89746 8.3125 9.625 7.58496 9.625 6.6875C9.625 5.79004 8.89746 5.0625 8 5.0625C7.10254 5.0625 6.375 5.79004 6.375 6.6875C6.375 7.58496 7.10254 8.3125 8 8.3125ZM8 9.3125C9.44975 9.3125 10.625 8.13725 10.625 6.6875C10.625 5.23775 9.44975 4.0625 8 4.0625C6.55025 4.0625 5.375 5.23775 5.375 6.6875C5.375 8.13725 6.55025 9.3125 8 9.3125Z"
      />
    </svg>
  )
})

export default Member
